<template>
	<b-row :class="(is_deleted ? 'archived-section' : ((is_full_disbursement || is_special_condition) ? '':'wait-full-disb-section'))">
		<b-col cols="12">
			<RedemptionSummary />
			<RedemptionDetail />
		</b-col>
	</b-row>
</template>

<script>
import RedemptionSummary from '@/views/CreditLoanCase/CaseDetail/CenterComponents/Redemption/RedemptionSummary'
import RedemptionDetail from '@/views/CreditLoanCase/CaseDetail/CenterComponents/Redemption/RedemptionDetail'
import { mapState } from 'pinia';
import { useLoanCaseStore } from '@/stores/loanCaseStore'

export default {
	components: {
		RedemptionSummary,
    RedemptionDetail
	},
	computed:{
		...mapState(useLoanCaseStore, ['activeCase']),
		is_full_disbursement(){
			let disb_status = _gHlp.getValue(this.activeCase,'disb_status_detail.name',null);
			return (!_gHlp.isEmpty(disb_status) && (disb_status == 'Full Disbursement'));
		},
		is_special_condition(){
			let status_id = _gHlp.getValue(this.activeCase,'status_id',null);
			return status_id == 49; //Credit Pull Back
		},
		is_deleted(){
			return !_gHlp.isEmpty(this.activeCase.deleted_at);
		}
  },
	
}
</script>